import { createSelector } from 'reselect';

const selectmainbanner = state => state.mainBanner;

export const selectMainBanner = createSelector(
    [selectmainbanner],
    (banner) => banner.mainBanner
)

export const selectMainBannerLoading = createSelector(
    [selectmainbanner],
    (banner) => banner.isMainBannerFetching
)